import { AnalyticsArticle } from '../interfaces/analyticsArticle';

export function convertToAnalyticsArticle(
  article: ArticleData,
  articleType: string,
) {
  const analyticsArticle: AnalyticsArticle = {
    id: article?.id,
    title: article?.title,
    section: '',
    tags: [],
    articleTypeInGA: articleType,
    subsection: '',
  };

  article?.tags?.map((tag) => {
    analyticsArticle.tags.push({ name: tag.name ?? '' });
  });

  return analyticsArticle;
}

export interface ArticleData {
  id: number;
  title: string;
  tags?: {
    name: string;
  }[];
}
